module.exports = __webpack_public_path__ + "media/images/emblems/Weiningen-blazon-e56328301f1d302cdd3311f13d8bbafd.svg";